import { Table } from "antd";

const Table6 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 'Nhóm 1',
            industry: 'Xăng dầu',
            visaVpb: '1.01%',
            visaOtherDomestic: '1.14%',
            masterVpb: '1.01%',
            masterOtherDomestic: '1.14%',
            jcbVpb: '1.01%',
            jcbOtherDomestic: '1.14%',
            uipOtherDomestic: '1.14%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 2,
            stt: 'Nhóm 2',
            industry:
                'Điện, Ga, nước. Phí vệ sinh, phí cầu đường. Dịch vụ Công (phí, án phí, thuế...). Dịch vụ vận tải, Giao dục (Trường học)',
            visaVpb: '1.22%',
            visaOtherDomestic: '1.27%',
            masterVpb: '1.22%',
            masterOtherDomestic: '1.27%',
            jcbVpb: '1.22%',
            jcbOtherDomestic: '1.27%',
            uipOtherDomestic: '1.39%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 3,
            stt: 'Nhóm 3',
            industry:
                'Siêu thị. Cửa hàng tiện ích của hàng thức phẩm, thức ăn nhanh, thức uống mang đi. Cước viễn thông/internet',
            visaVpb: '1.22%',
            visaOtherDomestic: '1.27%',
            masterVpb: '1.22%',
            masterOtherDomestic: '1.27%',
            jcbVpb: '1.22%',
            jcbOtherDomestic: '1.27%',
            uipOtherDomestic: '1.27%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 4,
            stt: 'Nhóm 4',
            industry: 'Taxi, Limousines',
            visaVpb: '1.39%',
            visaOtherDomestic: '1.52%',
            masterVpb: '1.39%',
            masterOtherDomestic: '1.52%',
            jcbVpb: '1.52%',
            jcbOtherDomestic: '2.66%',
            uipOtherDomestic: '2.53%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 5,
            stt: 'Nhóm 5',
            industry:
                'Phòng khám, Y tế. Dịch vụ giáo dục (Trung tâm, ...)',
            visaVpb: '1.64%',
            visaOtherDomestic: '2.66%',
            masterVpb: '1.39%',
            masterOtherDomestic: '1.64%',
            jcbVpb: '1.64%',
            jcbOtherDomestic: '2.66%',
            uipOtherDomestic: '1.64%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 6,
            stt: 'Nhóm 6',
            industry: 'Bệnh viện',
            visaVpb: '1.52%',
            visaOtherDomestic: '2.66%',
            masterVpb: '1.52%',
            masterOtherDomestic: '2.66%',
            jcbVpb: '1.52%',
            jcbOtherDomestic: '2.40%',
            uipOtherDomestic: '1.90%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 7,
            stt: 'Nhóm 7',
            industry: 'Điện tử, điện máy',
            visaVpb: '1.64%',
            visaOtherDomestic: '1.90%',
            masterVpb: '1.64%',
            masterOtherDomestic: '2.53%',
            jcbVpb: '1.64%',
            jcbOtherDomestic: '2.53%',
            uipOtherDomestic: '2.28%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
        {
            key: 8,
            stt: 'Nhóm 8',
            industry:
                'Chuỗi cửa hàng ngành mẹ và bé; Du lịch: Thời trang (bán lẻ), Nhà hàng. Khách sạn. Bất động sản. Rạp chiếu phim. Golf. Bán lẻ hóa mỹ phẩm; đá quý, nữ trang, đồng hồ và các nhóm ngành còn lại',
            visaVpb: '1.77%',
            visaOtherDomestic: '2.53%',
            masterVpb: '1.77%',
            masterOtherDomestic: '2.53%',
            jcbVpb: '1.77%',
            jcbOtherDomestic: '2.53%',
            uipOtherDomestic: '2.53%',
            foreignCard: '3.10%',
            domesticCard: '1.00%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 55,
            align: 'center',
        },
        {
            title: 'Các ngành nghề',
            dataIndex: 'industry',
            key: 'industry',
            width: 200,
        },

        {
            title: 'Thẻ Visa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            VPB
                        </>
                    ),
                    dataIndex: 'visaVpb',
                    key: 'visaVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: (
                        <>
                            Ngân hàng khác
                            <br />
                            Phát hành trong nước
                        </>
                    ),
                    dataIndex: 'visaOtherDomestic',
                    key: 'visaOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        {
            title: 'Thẻ Master',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            VPB
                        </>
                    ),
                    dataIndex: 'masterVpb',
                    key: 'masterVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: (
                        <>
                            Ngân hàng khác
                            <br />
                            Phát hành trong nước
                        </>
                    ),
                    dataIndex: 'masterOtherDomestic',
                    key: 'masterOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },

        {
            title: 'Thẻ JCB',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            VPB
                        </>
                    ),
                    dataIndex: 'jcbVpb',
                    key: 'jcbVpb',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
                {
                    title: (
                        <>
                            Ngân hàng khác
                            <br />
                            Phát hành trong nước
                        </>
                    ),
                    dataIndex: 'jcbOtherDomestic',
                    key: 'jcbOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },
        {
            title: 'UIP',
            children: [
                {
                    title: (
                        <>
                            Ngân hàng khác
                            <br />
                            Phát hành trong nước
                        </>
                    ),
                    dataIndex: 'uipOtherDomestic',
                    key: 'uipOtherDomestic',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                }
            ]
        },
        {
            title: (
                <>
                    Thẻ
                    <br />
                    Visa/Master
                    <br />
                    JCB/UIP
                    <br />
                    phát hành nước ngoài
                </>
            ),
            dataIndex: 'foreignCard',
            key: 'foreignCard',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },

        {
            title: (
                <>
                    Thẻ
                    <br />
                    Nội địa
                </>
            ),
            dataIndex: 'domesticCard',
            key: 'domesticCard',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-4 mb-3 text-center">BẢNG 6: BIỂU PHÍ POS KHÁCH LẺ – áp dụng với khách hàng sử dụng dịch vụ từ ngân hàng VPBank</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table6;